import { post } from '../apiService';

export const postSupport = body => {
    return post('/support', body);
};
export const postVersionAlert = body => {
    return post('/support/version', body);
};
